import DownloadService from '@/core/services/DownloadService';
import axios from 'axios';
import { ExitReenterAPIsConstants } from '../enums/daily-movements/ExitReenter';

const ExitReenterModule = {
   namespaced: true,
   state: {
      crudLoading: false,
      itemLoading: false,
      downloadLoading: false,
   },
   mutations: {
      SET_CRUD_LOADING(state, payload) {
         state.crudLoading = payload;
      },
      SET_ITEM_LOADING(state, payload) {
         state.itemLoading = payload;
      },
      SET_DOWNLOAD_LOADING(state, payload) {
         state.downloadLoading = payload;
      },
   },
   actions: {
      addItem({ commit }, { apiPath, credentials }) {
         commit('SET_CRUD_LOADING', true);

         return axios.post(`${apiPath}`, credentials).finally(() => {
            commit('SET_CRUD_LOADING', false);
         });
      },
      findItemById({ commit }, { apiPath, id, params }) {
         commit('SET_ITEM_LOADING', true);

         return axios.get(`${apiPath}/${id}`, { params }).finally(() => {
            commit('SET_ITEM_LOADING', false);
         });
      },
      extend({ commit }, { id, data }) {
         commit('SET_CRUD_LOADING', true);

         return axios.post(`${ExitReenterAPIsConstants.EXTEND}/${id}`, data).finally(() => {
            commit('SET_CRUD_LOADING', false);
         });
      },
      cancel({ commit }, { id }) {
         commit('SET_CRUD_LOADING', true);

         return axios.post(`${ExitReenterAPIsConstants.CANCEL}/${id}`).finally(() => {
            commit('SET_CRUD_LOADING', false);
         });
      },
      print({ commit }, { id }) {
         commit('SET_DOWNLOAD_LOADING', true);
         return DownloadService.downloadPDF(`${ExitReenterAPIsConstants.PRINT}/${id}`).finally(() =>
            commit('SET_DOWNLOAD_LOADING', false),
         );
      },
   },
};
export default ExitReenterModule;
